import { FocusMonitor } from '@angular/cdk/a11y'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { FileInputComponent } from './file-input.component'

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [FileInputComponent],
  providers: [FocusMonitor],
  exports: [FileInputComponent],
})
export class FileInputModule {}
